import { isEmpty, isUndefined } from 'lodash';
import i18n from 'i18next';
import {
  showNotification,
  clearNotification,
} from '../../helpers/notificationHelpers';

const isSuccessAction = (action) => /_SUCCESS$/.test(action.type);

const resolveErrorMessage = (action) => {
  if (action.showError) {
    let customMsg = 'requestFailed';

    if (isUndefined(action.error.response) || action.error.response.status === 503) {
      customMsg = 'applicationUnavailable';
    } else if (action.customMsg) {
      customMsg = action.customMsg;
    }

    const errors = action.error
        && action.error.response
        && action.error.response.data
        && action.error.response.data.errors;

    if (!!errors && typeof errors === 'object' && !isEmpty(errors)) {
      const errorsArr = Object.values(errors);
      if (errorsArr[0].length) {
        // eslint-disable-next-line prefer-destructuring
        customMsg = errorsArr[0][0];
      }
    }

    if (!i18n.exists(`errorNotifications.${customMsg}`)) {
      // for general message cases
      customMsg = customMsg.split('_').slice(0, 2).join('_');
      if (!i18n.exists(`errorNotifications.${customMsg}`)) {
        customMsg = 'requestFailed';
      }
    }

    const errMsgPath = `errorNotifications.${customMsg}`;
    showNotification(errMsgPath, 'error', action.type);
  }
};

export default function notificationMiddleware() {
  return () => (next) => (action) => {
    if (isSuccessAction(action)) {
      // dismiss corresponding error toast
      clearNotification(action.type.replace('_SUCCESS', '_FAIL'));
    }
    resolveErrorMessage(action);
    if (action.showSuccess) {
      const successMsgPath = `successNotifications.${action.type}`;
      showNotification(successMsgPath, 'success', action.type);
    }

    return next(action);
  };
}
